<template>
  <div id="modal-reorder" class="ui small modal">
    <div class="header">
      Reorder {{ payload.target }} in {{ payload.title }}
    </div>
    <div class="content">
      <div class="ui fluid vertical menu">
        <draggable :list="payload.items" @end="reorder">
          <div class="item" v-for="item in payload.items">
            {{ item.title }}
          </div>
        </draggable>
      </div>
    </div>
    <div class="actions">
      <button class="ui positive button" @click="close">Done</button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  props: ['payload'],

  components: {
    draggable
  },

  methods: {
    reorder () {
      this.$emit('reorder')
    },

    close () {
      this.$emit('close')
      window.$('#modal-confirm').modal('hide')
    }
  }
}
</script>

<style lang="scss" scoped>
  .ui.vertical.menu .item {
    &:hover {
      cursor: move;
    }

    &.sortable-chosen {
      background-color: #999;
    }

    &.sortable-ghost {
      background-color: #eee;
    }
  }
</style>



// WEBPACK FOOTER //
// ModalReorder.vue?35297c4a